import * as localStorage from '../libs/local-storage';
import { _ } from '../libs/lodash';
import { WorkspaceMetadataItem, WorkspacesMetadata } from '../types/workspace';

const WORKSPACE_METADATA_PATH = 'workspace_metadata';

export const getWorkspaceMetadata = (): WorkspacesMetadata => {
  const stored = localStorage.get({ path: WORKSPACE_METADATA_PATH });
  return (stored !== false ? (stored as WorkspacesMetadata) : {}) || {};
};

export const setWorkspaceMetadata = (data: Partial<WorkspacesMetadata>): void => {
  const current = getWorkspaceMetadata();
  const updated = { ...current, ...data };
  localStorage.set({ data: updated, path: WORKSPACE_METADATA_PATH });
};

export const getCurrentWorkspaceId = (context: 'research' | 'production'): number | undefined => {
  const metadata = getWorkspaceMetadata();
  return context === 'production' ? metadata.prodcurrentWorkspaceId : metadata.currentWorkspaceId;
};

export const setCurrentWorkspaceId = (workspaceId: number, context: 'research' | 'production'): void => {
  if (context === 'production') {
    setWorkspaceMetadata({ prodcurrentWorkspaceId: workspaceId });
  } else {
    setWorkspaceMetadata({ currentWorkspaceId: workspaceId });
  }
};

export const getLastItem = (context: 'research' | 'production'): WorkspaceMetadataItem | undefined => {
  const metadata = getWorkspaceMetadata();
  return context === 'production' ? metadata.prodlast : metadata.last;
};

export const getRecentItems = (context: 'research' | 'production'): WorkspaceMetadataItem[] => {
  const metadata = getWorkspaceMetadata();
  return (context === 'production' ? metadata.prodrecent : metadata.recent) || [];
};

export const addRecentItem = (item: WorkspaceMetadataItem, context: 'research' | 'production'): void => {
  const metadata = getWorkspaceMetadata();
  const recentKey = context === 'production' ? 'prodrecent' : 'recent';
  const lastKey = context === 'production' ? 'prodlast' : 'last';

  const currentRecent = metadata[recentKey] || [];

  const updatedRecent = _.uniqWith([item, ...currentRecent].slice(0, 10), _.isEqual) as WorkspaceMetadataItem[];

  setWorkspaceMetadata({
    [lastKey]: item,
    [recentKey]: updatedRecent,
  });
};

export const updateOnNavigation = (
  workspaceId: number,
  item: WorkspaceMetadataItem | null,
  context: 'research' | 'production'
): void => {
  const wsIdKey = context === 'production' ? 'prodcurrentWorkspaceId' : 'currentWorkspaceId';

  const updates: Partial<WorkspacesMetadata> = {
    [wsIdKey]: workspaceId,
  };

  if (item) {
    const metadata = getWorkspaceMetadata();
    const recentKey = context === 'production' ? 'prodrecent' : 'recent';
    const lastKey = context === 'production' ? 'prodlast' : 'last';
    const currentRecent = metadata[recentKey] || [];

    updates[lastKey] = item;
    updates[recentKey] = _.uniqWith([item, ...currentRecent].slice(0, 10), _.isEqual) as WorkspaceMetadataItem[];
  }

  setWorkspaceMetadata(updates);
};
